module.exports = __webpack_public_path__ + "img/banner1.bc10c0fa.png";